import React from 'react';
import type { TdHTMLAttributes } from 'react';
import { joinClasses, stackClasses } from './stack_table';
import type { StackAt } from './stack_table';

type StackTdProps = TdHTMLAttributes<HTMLTableCellElement> & {
  // Card-mode caption; omit for cells that read on their own (name, actions, empty state).
  label?: string;
  at?: StackAt;
};

function StackTd({ label, at = 'md', className, children, ...rest }: StackTdProps) {
  const c = stackClasses(at);
  return (
    <td
      data-label={label || undefined}
      className={joinClasses(className, c.cell, label && c.label)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
    </td>
  );
}

export default StackTd;
